export default "__VITE_ASSET__1c82f3e9__$_?component__"